import Flickity from 'flickity';

export default function single_rider() {
  if (!$('body').hasClass('single-rider')) return;

  var flkty = new Flickity( '.socialbox-gallery__content', {
    pageDots: false,
    on: {
      ready: function () {
        $('.socialbox-gallery__content .is-selected').prev().addClass('slide-prev');
        $('.socialbox-gallery__content .is-selected').next().addClass('slide-next');
      },
      change: function() {
        $('.socialbox-gallery__content .item').removeClass('slide-prev slide-next');
        $('.socialbox-gallery__content .is-selected').prev().addClass('slide-prev');
        $('.socialbox-gallery__content .is-selected').next().addClass('slide-next');
      }
    }
  });

  $('.block-accordion').each(function(){
    var _instance = this;
    $(this).find('.header-control').click(function(){
      $(this).find('i').toggleClass('fa-minus fa-plus');
      $(_instance).find('.block-accordion__content').slideToggle();
    });
  });
}
